import type React from 'react';

interface ITP extends React.HTMLAttributes<HTMLParagraphElement> {
	prompt: string;
	status?: boolean;
}

const TextPrompt: React.FC<ITP> = ({ prompt, status, ...props }) => (
	<>
		{prompt && (
			<p
				className='m-0 text-little'
				style={{
					color: status ? 'var(--color-success-text)' : 'var(--color-error-text)',
				}}
				{...props}
			>
				<span aria-hidden='true'>
					<i className={status ? 'fas fa-check-circle' : 'fas fa-info-circle'} />
					&nbsp;&nbsp;
				</span>
				{prompt}
			</p>
		)}
	</>
);

export default TextPrompt;
